import React, { useEffect, useState } from "react";
import "react-image-crop/dist/ReactCrop.css";
import "./style.css";

import { Helmet } from "react-helmet-async";
import NavbarTop from "../../components/NavbarTop";
import ScreenModal from "../Layouts/ScreenModal/ScreenModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useMessage } from "../../global-components/src";
import { errorMessage } from "../../utils/TextManagerTwo";
import Spinner from "../../global-components/src/components/spinner/spiner";
import { PACOCA_API_URL } from "../../global-components/src/utils/vars";
import LeftPanel from "../Login/left-panel";
import { t } from "i18next";
import { isWeakPassword } from "../../global-components/src/utils/password-security";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState("");
  const [token, setToken] = useState<string | null>(null);
  const [email, setEmail] = useState<string | null>(null);
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [errorsInput, setErrorsInput] = useState<{ password?: string[]; passwordConfirmation?: string[] }>({});
  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isVisibleConfirmation, setIsVisibleConfirmation] = useState(false);
  const { setMessage } = useMessage();
  const navigate = useNavigate();

  // Captura os parâmetros da URL ao carregar a página
  useEffect(() => {
    setToken(searchParams.get("token"));
    setEmail(searchParams.get("email"));

    if (!searchParams.get("token") || !searchParams.get("email")) {
      navigate("/")
    }
  }, [searchParams]);


  const handleResetPassowrd = async () => {
    try {
      let errors: Record<string, string[]> = {};
      if (password.length < 8) {
        errors.password = [t("errors.input.minLength", { field: t("inputs.password"), min: 8 })];
      }
      if (!password) {
        errors.password = [t("errors.input.required", { field: t("inputs.password") })];
      } else if (isWeakPassword(password)) {
        errors.password = [t("errors.input.passwordWeak")];
      }
      if (password != passwordConfirmation) {
        errors.password = [t("errors.input.passwordMismatch")];
      }

      if (Object.keys(errors).length > 0) {
        throw {
          response: {
            data: {
              errors
            }
          }
        };
      }

      setLoading(true)

      const response = await axios.post(`${PACOCA_API_URL}/reset-password`, {
        email, token, password, password_confirmation: passwordConfirmation
      }, {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        }
      });

      const data = response.data;
      const message = data.message || t("resetPassword.successMessage");
      const title = data.title || null;
      const type = data.type_message || "success";
      setMessage(message, type, title)
      navigate("/login");
    } catch (err: any) {
      if (err?.response?.data.errors) {
        setErrorsInput(err.response.data.errors); // Atualiza o estado com os erros
      } else {
        const type = err?.response?.data?.type_message || "error";
        const messageError = errorMessage(err)
        setMessage(messageError, type, t("resetPassword.errorTitle"))
        console.error('Erro:', err);
        console.error(messageError);
      }
    } finally {
      setLoading(false)
    }
  }

  const verifyPasswordConfirmation = () => {
    let errors: Record<string, string[]> = {};

    if (password.length == passwordConfirmation.length && password != passwordConfirmation) {
      errors.password = [t("errors.input.passwordMismatch")];
    } else {
      delete errors.password;
    }
    setErrorsInput(errors);
  };

  useEffect(() => {
    verifyPasswordConfirmation()
  }, [password, passwordConfirmation])

  return (
    <>
      <Helmet>
        <title>{`Paçoca - ${t("resetPassword.title")}`}</title>
      </Helmet>
    <div className="container-login">
      <div className="auth-layout">
        <LeftPanel />

        <div className="auth-panel-right">
          <div className="auth-logo">
              <img src="/img/pacoca-sem-braco.png" alt="Paçoca" className="auth-logo__img" />
          </div>
          <div className="auth-form" id='form-login'>
              <h1 className="auth-title">{t("resetPassword.title")}</h1>
              <p className="auth-subtitle">{t("resetPassword.subtitle")}</p>
              
              <div className="auth-field">
                <label htmlFor="password" className="required text-md-right">{t("resetPassword.newPassword")}</label>

                <div className="auth-field__wrap">
                  <span className="auth-field__icon">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                  </span>
                  <input id="password" type={isVisible ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} className={`auth-input ${errorsInput.password ? "auth-input--error" : ""}`} autoComplete="off" />
                  {/* {{-- IMAGEM DE VER SENHA --}} */}
                  <img
                    className="view-password user-select-none"
                    id="view-password"
                    src={isVisible ? "/img/eye-off.svg" : "/img/eye.svg"}
                    alt={t("resetPassword.showPassword")}
                    onClick={() => setIsVisible(!isVisible)}
                    style={{ height: "18px", cursor: "pointer", position: "absolute", right: "15px", top: "50%", transform: "translateY(-50%)" }}
                  />
                </div>
                {errorsInput.password && (
                  <div role="alert" className="invalid-feedback" style={{ display: "block" }}>{errorsInput.password[0]}</div> // Exibe a mensagem de erro
                )}
              </div>

              <div className="auth-field">
                <label htmlFor="password" className="required text-md-right">{t("inputs.passwordConfirmation")}</label>

                <div className="auth-field__wrap">
                  <span className="auth-field__icon">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                  </span>
                  <input id="password" type={isVisibleConfirmation ? "text" : "password"} value={passwordConfirmation} onChange={(e) => setPasswordConfirmation(e.target.value)} className={`auth-input ${errorsInput.passwordConfirmation ? "auth-input--error" : ""}`} autoComplete="off" />
                  {/* {{-- IMAGEM DE VER SENHA --}} */}
                  <img
                    className="view-password user-select-none"
                    id="view-password"
                    src={isVisibleConfirmation ? "/img/eye-off.svg" : "/img/eye.svg"}
                    alt={t("resetPassword.showPassword")}
                    onClick={() => setIsVisibleConfirmation(!isVisibleConfirmation)}
                    style={{ height: "18px", cursor: "pointer", position: "absolute", right: "15px", top: "50%", transform: "translateY(-50%)" }}
                  />
                </div>
                {errorsInput.passwordConfirmation && (
                  <div role="alert" className="invalid-feedback" style={{ display: "block" }}>{errorsInput.passwordConfirmation[0]}</div> // Exibe a mensagem de erro
                )}
              </div>

              <div className="form-group">
                <div className="col link-criar-conta">
                    <button onClick={handleResetPassowrd} disabled={loading} className="auth-btn-primary">
                      {loading ? (
                        <>
                          <Spinner />
                        </>
                      ) : (
                        <>{t("resetPassword.submit")}</>
                      )}
                  </button>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
